import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import { useParams } from 'react-router-dom';
import './styles/TransferInventoryPage.css';
import { useNavigate } from 'react-router-dom'; 

const InventoryPriceFormPage = () => {
    const { inventoryId } = useParams(); 
    const [inventory, setInventory] = useState(null); // Ubah ke null untuk memudahkan pengecekan
    const [price, setPrice] = useState('');
    const [itemName, setItemName] = useState('');
    const [itemType, setItemType] = useState('');
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        api.post('/inventory/getInventoryFromId', { data: { inventoryId: inventoryId }})
          .then(response => {
            const inventoryData = response.data.data; 
            setInventory(inventoryData);
            setItemName(inventoryData.item_name); 
            setItemType(inventoryData.item_type); 
            setPrice(inventoryData.price); 
        })
          .catch(error => console.error('Error fetching inventory price data:', error));
        
    }, [inventoryId]);
    
    const formatCurrency = (amount) => {
        return parseFloat(amount).toLocaleString('id-ID', { minimumFractionDigits: 0 });
    };
    
    const handlePriceChange = (e) => {
        const value = e.target.value.replace(/\./g, '');
        if (value === '') {
            setPrice(0);
        } else {
            e.target.value = formatCurrency(value); 
            setPrice(value); // Simpan nilai asli tanpa format
        }
    };

    const validateForm = () => {
        const errors = {};
        if (price === 0) errors.price = 'Price is required';
        return errors;
    };
   
    const handleSubmit = () => {
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            console.log('Validation Errors:', validationErrors);
        } else {
            const confirmation = window.confirm('Are you sure you want to proceed with this action?');
            if (!confirmation) {
                return;
            }
            
            const inventoryData = {
                data: {
                    inventoryData: {
                        inventory_id: inventory.inventory_id,
                        price: price
                    },
                },
            };

            console.log(inventoryData);
        
            api.post(`inventory/priceUpdate`, inventoryData)
            .then(response => {
                const successMessage = response.data.message;
                console.log(successMessage);
                navigate('/success', { state: { message: successMessage } });
            })
            .catch(error => {
                console.error('Error updating price:', error);
                navigate('/error', { state: { message: 'Please ask to administrator!' } });
            });
        }
    };

    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Price Edit</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Item Data</h3>
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Item Name</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="text"
                                            value={itemName} 
                                            readOnly
                                        />
                                    </td>  
                                </tr>
                                <tr>
                                    <td>
                                        <label>Item Type</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="text"
                                            value={itemType} 
                                            readOnly
                                        />
                                    </td> 
                                </tr>
                                <tr>
                                    <td>
                                        <label>Item Price</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="text" // Ubah ke text untuk format mata uang
                                            value={formatCurrency(price)}      
                                            onChange={handlePriceChange} 
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    {errors.price && 
                                    <td>
                                        <div className="error-message">{errors.price}</div>
                                    </td>
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="search-container">
                    <button className="profile-button" onClick={handleSubmit}>Submit</button>
                </div>
            </div>
        </div>
    );
};

export default InventoryPriceFormPage;
